import React from 'react';

const ClipboardDocumentCheckIcon: React.FC = () => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        className="h-8 w-8 sm:h-10 sm:w-10" 
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor" 
        strokeWidth={1.5}
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.125 2.25h-4.5c-1.125 0-2.063.938-2.063 2.063v15.374c0 1.125.938 2.063 2.063 2.063h12.75c1.125 0 2.063-.938 2.063-2.063V12.375m-14.437-9.375l.563-.563a2.063 2.063 0 012.912 0l2.063 2.063M10.125 2.25L12.188 4.312m0 0l2.063 2.063m-2.063-2.063l2.063-2.063m-2.063 2.063l-2.063 2.063m6.938 6.938l-2.063-2.063m0 0l-2.063 2.063m2.063-2.063l2.063 2.063M19.5 12.375l-2.063-2.063m0 0l2.063-2.063m-2.063 2.063L15.375 6" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.375l1.5-1.5m0 0l1.5 1.5m-1.5-1.5V12.375m0 6l-1.5 1.5m1.5-1.5l1.5 1.5" />
    </svg>
);

export default ClipboardDocumentCheckIcon;